import * as PrefabManager from '../PrefabManager'
import { Explosive } from './Explosive';
import * as PhysicsParticleEmitter from '../../utils/PhysicsParticleEmitter';
import * as PrefabBuilder from '../../utils/PrefabBuilder';
import * as AudioManager from '../../utils/AudioManager';
import { gameRandom } from '../../utils/GameRandom';


import {
    game
} from "../../Game";

const vec1 = new Box2D.b2Vec2();
const vec2 = new Box2D.b2Vec2();

class ExplosiveBarrel extends Explosive {
    constructor(target) {
        super(target);
    }
    init() {
		super.init();
		this.explosiveRadius = 600;
		this.explosionScale = 1;
		this.activateOn = Explosive.activateOnTypes.impact;
		this.explodeDelay = 0;
		this.impactForExplosion = 10000;
	}
	explode(){
		if(this.exploded || this.explosionQueued) return;

		this.explodeTarget = this.lookupObject['explosiveBody'];
		super.explode();
	}
	performExplosion(){
		if(this.exploded || this.destroyed) return;
		super.performExplosion();

		const pos = this.explodeTarget.GetPosition();

		const prefabData = PrefabBuilder.generatePrefab(pos, 0, 'ExplosiveBarrelBottom', true);
		const { lookupObject } = prefabData;
		const body = lookupObject._bodies[0];
		const force = 1500 / game.editor.editorSettingsObject.gameSpeed;
		const offset = 0.5;
		const impulse = vec1;
		impulse.Set((gameRandom()*(force*2)-force), (gameRandom()*(force*2)-force));
		const point = vec2;
		point.Set(body.GetPosition().get_x()+(gameRandom()*(offset*2)-offset), body.GetPosition().get_y()+(gameRandom()*(offset*2)-offset));
		body.ApplyForce(impulse, point, true);

		// The explosion effect still supplies the visual burst. Avoid adding
		// colliding cardboard bodies when dozens of bodies already share the blast;
		// those particles turn pathological barrel piles into contact-pair storms.
		if(!this.denseExplosion){
			PhysicsParticleEmitter.emit(['Cardboard_1', 'Cardboard_2', 'Cardboard_3'], pos, 20, 5, 20, false, [0x752E00, 0x98440D]);
		}

		AudioManager.playSFX('barrel-explosion', 0.3, 1.0 + 0.4 * Math.random()-0.2, body.GetPosition());


		this.destroy();
	}
	set(property, value) {
		super.set(property, value);
        switch (property) {
            case 'active':
                this.setActive(value);
                break;
        }
    }
}

ExplosiveBarrel.settings = Object.assign({}, Explosive.settings, {force:6000});
delete ExplosiveBarrel.settings.active;
delete ExplosiveBarrel.settings.delay;
delete ExplosiveBarrel.settings.activateOn;

ExplosiveBarrel.settingsOptions = Object.assign({}, Explosive.settingsOptions);
delete ExplosiveBarrel.settingsOptions.active;
delete ExplosiveBarrel.settingsOptions.delay;
delete ExplosiveBarrel.settingsOptions.activateOn;



PrefabManager.prefabLibrary.ExplosiveBarrel = {
    json: '{"objects":[[0,-0.04601924674682996,-0.22858055065911953,0,"explosiveBarrel","explosiveBody",0,["#999999"],["#000"],[0],false,true,[[{"x":-2.0574512567209604,"y":3.3417201940372285},{"x":-2.0574512567209604,"y":-3.3417201940372285},{"x":2.0574512567209604,"y":-3.3417201940372285},{"x":2.0574512567209604,"y":3.3417201940372285}]],[1],0,[0],"",[1]],[1,-0.4077612717285123,-13.253638034478469,0,"explosiveBarrel","explosiveTexture",1,"Tank_Flamable0000",0,6.469777499209521,1.4198607371241059,0,false,"#FFFFFF",1,1,1]]}',
    class: ExplosiveBarrel,
    library: PrefabManager.LIBRARY_WEAPON,
}

PrefabManager.prefabLibrary.ExplosiveBarrelBottom = {
	json: '{"objects":[[0,-0.04159315440056843,0.058112796535037564,0,"explosiveTankBottom","body",0,["#999999"],["#000"],[0],false,true,[[{"x":-2.0588611428281127,"y":0.6654904704090869},{"x":-2.0588611428281127,"y":-0.6654904704090869},{"x":2.0588611428281127,"y":-0.6654904704090869},{"x":2.0588611428281127,"y":0.6654904704090869}]],[1],0,[0],"",[1]],[1,-1.9292498990856641,-9.977508723075704,0,"explosiveTankBottom","texture",1,"Tank_Flamable_off0000",0,11.740685885846592,1.6288711684514927,0,false,"#FFFFFF",1,1,1]]}',
	class: PrefabManager.basePrefab,
}
